module.exports = __webpack_public_path__ + "img/bespoke123_05.a6fff673.jpg";